<template>
  <v-layout row justify-center>
    <dialog-wrapper :visible="dialog">
      <v-dialog v-model="dialog" max-width="700">
        <v-card class="px-2" style="position: initial;">
          <v-card-text class="pb-0">
            <h3 class="headline"><span v-t="'editingContainer.createLink'" /></h3>
          </v-card-text>
          <v-card-text>
            <v-layout>
              <v-checkbox v-model="selectedDays" color="primary" :label="$t('common.monday')" value="1" />
              <v-checkbox v-model="selectedDays" color="primary" :label="$t('common.tuesday')" value="2" />
              <v-checkbox v-model="selectedDays" color="primary" :label="$t('common.wednesday')" value="3" />
              <v-checkbox v-model="selectedDays" color="primary" :label="$t('common.thursday')" value="4" />
              <v-checkbox v-model="selectedDays" color="primary" :label="$t('common.friday')" value="5" />
            </v-layout>
            <v-layout>
              <v-flex xs4>
                <date-picker
                  :selected-date="selectedDate"
                  :label="'editingContainer.selectedWeek'"
                  :disabled-weekdays="[1, 3, 4, 5, 6, 7]"
                  @onDateUpdate="date => selectedDate = date"
                />
              </v-flex>
              <v-flex xs3>
                <v-combobox
                  v-model="providerColor"
                  :items="colors"
                  item-text="name"
                  :label="$t('editingContainer.providerColor')"
                  height="32px"
                  chips
                  browser-autocomplete="off"
                  required
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip small :color="data.item.toLocaleLowerCase()" text-color="white">{{ data.item }}</v-chip>
                  </template>
                </v-combobox>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-autocomplete
                ref="providerName"
                v-model="providerData.name"
                :items="activeProvidersData"
                :item-text="(p) => p.name"
                :label="$t('editingContainer.providerName')"
                required
                :name="$t('editingContainer.providerName')"
                @change="onChangeProviderName"
              />
              <v-btn
                class="mt-3"
                color="primary"
                flat
                :disabled="isGenerateDisabled"
                :loading="generatingLink"
                @click="generateLink"
              ><span v-t="'editingContainer.generateLink'" /></v-btn>
            </v-layout>
          </v-card-text>
          <v-card-actions v-show="providerLink" class="pl-2">
            <v-text-field
              ref="providerLink"
              readonly
              :value="providerLink"
              append-icon="content_copy"
              :label="$t('editingContainer.link')"
              @click:append="copyLink"
              @focus="e => e && e.target.select()"
            />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </dialog-wrapper>
  </v-layout>
</template>

<script>
import ErrorHandler from '@/services/ErrorHandler';
import NotificationService from '@/services/NotificationService';
import DatePicker from '@/components/common/date-picker/DatePicker.vue';
import gql from 'graphql-tag';
import moment from 'moment';
import DialogWrapper from '../../common/dialog-wrapper/DialogWrapper.vue';

export default {
  name: 'CreateLinkModal',
  components: {
    'date-picker': DatePicker,
    DialogWrapper,
  },
  data: () => ({
    colors: ['Red', 'Green'],
    dialog: false,
    providerColor: null,
    providerData: {
      name: null,
      id: null,
    },
    activeProvidersData: [],
    selectedDate: moment().startOf('isoWeek').add(7, 'days').format('YYYY-MM-DD'),
    selectedDays: [],
    generatingLink: false,
    providerLink: null,
  }),
  computed: {
    upcomingMondays() {
      const thisMonday = moment().startOf('isoWeek');
      const mondays = [
        moment(thisMonday),
        moment(thisMonday.add(7, 'days')),
        moment(thisMonday.add(7, 'days')),
        moment(thisMonday.add(7, 'days')),
        moment(thisMonday.add(7, 'days')),
      ];

      return mondays.map(m => m.format('YYYY-MM-DD'));
    },
    isGenerateDisabled() {
      return !this.providerData.name || this.selectedDays.length === 0 || !this.selectedDate || !this.providerColor;
    },
  },
  methods: {
    open() {
      this.dialog = true;
      this.providerData.name = null;
      this.providerColor = null;
      this.selectedDate = moment().startOf('isoWeek').add(7, 'days').format('YYYY-MM-DD');
      this.selectedDays = [];
      this.providerLink = null;
    },
    copyLink() {
      this.$refs.providerLink.focus();
      setTimeout(() => document.execCommand('copy'), 100);
    },
    async generateLink() {
      this.generatingLink = true;
      try {
        const result = await this.$apollo.mutate({
          mutation: gql`mutation createExternalLinkMutation($days: [Int]!, $selectedWeek: TimelessDate!, $providerColor: String!, $providerDataId: Int!) {
            createExternalLink(days: $days, selectedWeek: $selectedWeek, providerColor: $providerColor, providerDataId: $providerDataId)
          }`,
          variables: {
            days: this.selectedDays,
            selectedWeek: this.selectedDate,
            providerColor: this.providerColor,
            providerDataId: this.providerData.id,
          },
        });

        this.providerLink = `${window.location.origin}/newProvider/${result.data.createExternalLink}`;
        setTimeout(() => this.$refs.providerLink.focus(), 100);
      } catch (error) {
        ErrorHandler.handleApolloError(error);
      } finally {
        this.generatingLink = false;
      }
    },
    onChangeProviderName(providerName) {
      const selectedProviderName = this.activeProvidersData.find(ap => ap.name === providerName);
      this.providerData.id = selectedProviderName.id;
    },
  },
  apollo: {
    activeProvidersData: {
      fetchPolicy: 'network-only',
      query: gql`query ActiveProviderNamesQuery {
        activeProvidersData {
          id
          name
        }
      }`,
      error(error) {
        ErrorHandler.handleApolloError(error);
      },
      result(r) {
        if (!r.loading) {
          NotificationService.clearNetworkNotification();
        }
      },
    },
  },
};
</script>
